import {CSSProperties, FC} from 'react';


export interface IIconCarSeatLeftProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconCarSeatLeft: FC<IIconCarSeatLeftProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 113 113"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path d="M22.225 86.377c2.17-8.158 12.311-8.373 17.763-8.486 4.526-.096 9.346.113 14.323.627 3.068.317 7.012.859 10.848 2.237-.135-.242-.26-.474-.384-.7-2.882-5.35-3.023-11.837-2.882-16.25.198-6.05 1.424-12.017 3.628-17.74a54.876 54.876 0 0 1 3.96-8.182 54.375 54.375 0 0 1 2.48-3.808c.08-.113.334-.424.718-.881a63.643 63.643 0 0 0 1.633-2.023c-1.774-3.186-3.932-7.119-4.576-11.452-.582-3.893.186-9.142 4.107-12.199 1.622-1.26 3.492-1.876 5.277-1.729 4.526.385 6.848 5.26 7.633 7.34 2.097 5.542 2.424 11.593 2.47 16.25.073 7.056-.492 13.955-.995 19.17-.277 2.875-.599 5.796-.881 8.373l-.012.09c-.44 4.017-.898 8.176-1.226 12.266-.203 2.566-.372 5.181-.542 7.707l-.011.17c-.283 4.361-.577 8.87-1.051 13.305-.062.582-.113 1.175-.17 1.78-.226 2.48-.457 5.045-1.31 7.39-1.357 3.729-4.215 4.407-6.826 4.577-2.09.141-4.186-.017-6.21-.17l-.112-.005c-1.271-.096-2.588-.198-3.87-.221-1.803-.034-3.633-.113-5.407-.186-1.718-.074-3.272-.141-4.837-.175-8.141-.187-14.803.067-20.956.802-1.05.124-2.068.022-2.859.022-1.87 0-3.3-.18-4.836-.92-1.994-.961-3.864-2.102-4.752-5.537-.994-3.842-1.045-8.012-.135-11.442Zm22.634-2.943-1.272.022c-3.43.057-7.322.124-10.57.712-1.295.232-2.764.554-3.831 1.39-.96.751-1.662 1.994-1.972 3.497-.3 1.452-.237 3-.141 4.464.09 1.373.237 2.797.977 3.797.616.83 1.69 1.418 3.017 1.644 1.232.209 2.548.107 3.82.011l.14-.011a216.692 216.692 0 0 1 37.472.463c.316.034.644.074.977.113 1.316.17 2.678.345 3.814-.096 1.356-.52 1.734-2.339 2.073-3.944l.057-.26-1.159-.807c-5.237-3.656-10.18-7.114-16.458-9.063-4.729-1.463-10.108-2.074-16.944-1.932Zm37.375-68.32c-.791-1.718-2.283-3.458-3.826-3.458-.197 0-.39.028-.582.085-1.073.322-1.757 1.497-2.135 2.43-1.673 4.079-.774 9.339 2.344 13.74l.17.237c.593.83 1.266 1.769 1.373 2.944.164 1.825-1.034 3.232-2.09 4.48a45.099 45.099 0 0 0-1.323 1.633c-4.232 5.486-7.226 12.007-8.655 18.854-1.763 8.43-2.289 19.956 5.226 27.013 2.463 2.316 4.497 4.068 7.356 5.932.04-1.209.045-2.423.057-3.52.005-1.09.017-2.22.045-3.327.248-8.244 1.265-16.56 2.254-24.629 1.062-8.661 2.159-17.622 2.283-26.464.068-5.046-.175-10.888-2.497-15.95Z" />
        </svg>
    );
};
